import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { largeScreen, smallScreen } from '../../../../../common/mixins';

const rules = ({ theme, isOpen }) => ({
  background: theme.color.controlsMenuBgColor,
  borderRadius: theme.radius.small,
  bottom: '44px',
  display: 'flex',
  opacity: '0',
  padding: `0 ${theme.margin.medium}`,
  overflow: 'hidden',
  position: 'absolute',
  right: theme.margin.xlarge,
  transform: 'scale(0)',
  transition: '150ms all',

  extend: [
    largeScreen({
      right: theme.margin.large,
    }),
    smallScreen({
      right: theme.margin.small,
    }),
    {
      condition: isOpen,
      style: {
        opacity: '1',
        transform: 'scale(1)',
      },
    },
  ],
});

const SettingsContainer = React.forwardRef(({ onMouseEnter, onMouseLeave, isOpen, children }, ref) => {
  const { css } = useFela({ isOpen });

  return (
    <div
      ref={ref}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={css(rules)}
      data-cy="hp-settings-menu"
    >
      {children}
    </div>
  );
});

SettingsContainer.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
};

export default React.memo(SettingsContainer);
